// Shim: web-ifc-three importa BufferGeometryUtils como namespace.
// r151+ renomeou mergeBufferGeometries → mergeGeometries (o antigo só emite console.warn).
import * as _bgu from "three/examples/jsm/utils/BufferGeometryUtils";

export const BufferGeometryUtils = {
  ..._bgu,
  mergeBufferGeometries: (geoms, useGroups = false) =>
    _bgu.mergeGeometries(geoms, useGroups),
  mergeBufferAttributes: (attrs) => _bgu.mergeAttributes(attrs),
};

export * from "three/examples/jsm/utils/BufferGeometryUtils";
